module.exports = __webpack_public_path__ + "img/close.17cc8512.svg";